<span class="hx-tag__content">
  @if (hasStartIcon()) {
    <span aria-hidden="true" class="hx-tag__icon">
      <!-- Icon implementation will be added in Phase 7 (US5) -->
      <!-- For now, this is a placeholder for the icon system integration -->
    </span>
  }

  @if (maxWidth()) {
    <span class="hx-tag__label" [style]="truncationStyles()" hxEllipsisTooltip [hxEllipsisTooltip]="label()">
      {{ label() }}
    </span>
  } @else {
    <span class="hx-tag__label">{{ label() }}</span>
  }

  <ng-content />

  @if (removable() && !disabledState()) {
    <span (click)="onRemoveClick()" class="hx-tag__close">
      <hx-icon [size]="'md'" class="hx-tag__close-icon" [attr.aria-hidden]="true" svgIcon="x" />
    </span>
  }
</span>
